export const VERTICALS = {
  SNEAKERS: 'Sneakers',
  SHOES: 'Shoes',
  ELECTRONICS: 'Electronics',
  COLLECTIBLES: 'Collectibles',
  TRADING_CARDS: 'Trading Cards',
  APPAREL: 'Apparel',
  ACCESSORIES: 'Accessories',
};

export const VERTICALS_ARR = [
  { text: VERTICALS.SNEAKERS, url: 'sneakers' },
  { text: VERTICALS.SHOES, url: 'shoes' },
  { text: VERTICALS.APPAREL, url: 'apparel' },
  { text: VERTICALS.ELECTRONICS, url: 'electronics' },
  { text: VERTICALS.TRADING_CARDS, url: 'trading-cards' },
  { text: VERTICALS.COLLECTIBLES, url: 'collectibles' },
  { text: VERTICALS.ACCESSORIES, url: 'accessories' },
];

export const VERTICALS_WITH_GENDERS_ARR = [
  { text: VERTICALS.SNEAKERS, url: 'sneakers' },
  { text: VERTICALS.SHOES, url: 'shoes' },
  { text: VERTICALS.APPAREL, url: 'apparel' },
  { text: VERTICALS.ACCESSORIES, url: 'accessories' },
  { text: VERTICALS.ELECTRONICS, url: 'electronics' },
  { text: VERTICALS.TRADING_CARDS, url: 'trading-cards' },
  { text: VERTICALS.COLLECTIBLES, url: 'collectibles' },
  { text: 'Men', url: 'sneakers?size_types=men' },
  { text: 'Women', url: 'sneakers?size_types=women' },
  { text: 'Kids', url: 'sneakers?size_types=child' },
];

export const VERTICALS_ARR_LC = VERTICALS_ARR.map((vertical) => ({
  text: vertical.text.toLowerCase(),
  url: vertical.url,
}));

export const VERTICAL_URL_PARTS = [
  'sneakers',
  'shoes',
  'electronics',
  'collectibles',
  'trading-cards',
  'apparel',
  'accessories',
];
